import {KJUR, b64tohex, hextob64} from 'jsrsasign';

export default class SignatureManager {
    static async sign(privateKeyPem: string, data: string): Promise<string> {
        try {
            const keyToUse = `-----BEGIN PRIVATE KEY-----${privateKeyPem}-----END PRIVATE KEY-----`;
            const sig = new KJUR.crypto.Signature({alg: "SHA256withECDSA"});
            sig.init(keyToUse);
            sig.updateString(data);
            const hexSignature = sig.sign();

            return hextob64(hexSignature);
        } catch (err) {
            console.error("Signing error:", err);
            throw err;
        }
    }

    static async verify(publicKeyPem: string, signatureBase64: string, data: string): Promise<boolean> {
        try {
            const keyToUse = `-----BEGIN PUBLIC KEY-----${publicKeyPem}-----END PUBLIC KEY-----`;
            const sig = new KJUR.crypto.Signature({alg: "SHA256withECDSA"});
            sig.init(keyToUse);
            sig.updateString(data);

            const hexSignature = b64tohex(signatureBase64);

            return sig.verify(hexSignature);
        } catch (err) {
            console.error("Verification error:", err);
            return false;
        }
    }

    private static hexToBytes(hex: string): Uint8Array {
        const bytes = new Uint8Array(hex.length / 2);
        for (let i = 0; i < hex.length; i += 2) {
            bytes[i / 2] = parseInt(hex.substr(i, 2), 16);
        }
        return bytes;
    }

    private static bytesToHex(bytes: Uint8Array): string {
        return Array.from(bytes)
            .map(byte => byte.toString(16).padStart(2, '0'))
            .join('');
    }

    private static bytesToBase64(bytes: Uint8Array): string {
        let binary = '';
        for (let i = 0; i < bytes.length; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
    }

    private static base64ToBytes(base64: string): Uint8Array {
        try {
            // Clean the base64 string (remove whitespace and padding if needed)
            const cleanBase64 = base64.replace(/\s/g, '');

            const binary = atob(cleanBase64);
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
            return bytes;
        } catch (err) {
            console.error("Error in base64ToBytes:", err);
            console.error("Input base64:", base64);
            throw err;
        }
    }

    private static isValidBase64(str: string): boolean {
        try {
            // Check if string contains only valid base64 characters
            const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
            const cleanStr = str.replace(/\s/g, '');

            if (!base64Regex.test(cleanStr)) {
                return false;
            }

            // Try to decode it
            atob(cleanStr);
            return true;
        } catch (err) {
            return false;
        }
    }
}
